module.exports = __webpack_public_path__ + "img/blog-7.f03637c4.jpg";